import { Module } from 'vuex-smart-module';
import Editable from '@/modules/courses-requests/store/modules/editable/store';
import CoursesRequestsActions from './actions';
import CoursesRequestsGetters from './getters';
import CoursesRequestsMutations from './mutations';
import CoursesRequestsState from './state';

export default new Module({
  state: CoursesRequestsState,
  mutations: CoursesRequestsMutations,
  actions: CoursesRequestsActions,
  getters: CoursesRequestsGetters,
  modules: {
    editable: Editable,
  },
});
